export const SYSTEM_FILES = {
  DS_STORE: '.DS_Store',
  MAC_RESOURCE_FORKS: '._',
  WINDOWS_THUMBS: 'Thumbs.db',
  WINDOWS_DESKTOP: 'desktop.ini',
} as const;

export const SYSTEM_FILE_PATTERNS = [
  SYSTEM_FILES.DS_STORE,
  SYSTEM_FILES.WINDOWS_THUMBS,
  SYSTEM_FILES.WINDOWS_DESKTOP,
] as const;

export const isSystemFile = (fileName: string): boolean => {
  return (
    SYSTEM_FILE_PATTERNS.includes(fileName as any) ||
    fileName.startsWith(SYSTEM_FILES.MAC_RESOURCE_FORKS)
  );
};

export const normalizeRelativePath = (path: string): string => {
  return path.endsWith('/') ? path.slice(0, -1) : path;
};

export const extractFolderStructure = (webkitRelativePath: string): {
  folderPath: string;
  allFolderPaths: string[];
} => {
  const pathParts = webkitRelativePath.split('/');
  
  if (pathParts.length <= 1) {
    return { folderPath: '', allFolderPaths: [] };
  }

  pathParts.pop(); 
  const folderPath = pathParts.slice(1).join('/'); 

  const allFolderPaths: string[] = [];
  for (let i = 2; i <= pathParts.length; i++) {
    const partialPath = pathParts.slice(1, i).join('/');
    if (partialPath) {
      allFolderPaths.push(partialPath);
    }
  }

  return { folderPath, allFolderPaths };
};

export const hasDraggedFiles = (dataTransfer: DataTransfer | null): boolean => {
  return !!(dataTransfer?.items && dataTransfer.items.length > 0);
};

export const filterSystemFiles = <T extends { name: string }>(files: T[]): T[] => {
  return files.filter(file => !isSystemFile(file.name));
};
